import WaitingScreen from './WaitingScreen';
export default WaitingScreen;
